<template>
  <div style="border: 1px solid #ccc; margin-top: 10px;">
    <!-- 工具栏 -->
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
    />
    <!-- 编辑器 -->
    <WangEditor
      style="height: 800px;
      overflow-y: hidden;"
      :defaultConfig="this.getEditorConfig()"
      v-model="currentValue"
      @onChange="onChange"
      @onCreated="onCreated"
    />
  </div>
</template>
<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import {generateFilePath, uploadObject, uploadOss} from "@/api/tool/oss";
export default {
  name: 'Editor',
  components: {
    'WangEditor': Editor,
    Toolbar
  },
  props: {
    /* 编辑器的内容 */
    value: {
      type: String,
      default: ''
    },
    /* 高度 */
    height: {
      type: Number,
      default: null
    },
    /* 只读 */
    readOnly: {
      type: Boolean,
      default: false
    },
    // 上传文件大小限制(MB)
    fileSize: {
      type: Number,
      default: 1024
    },
    imageSize: {
      type: Number,
      default: 20
    },
    videoSize: {
      type: Number,
      default: 1024
    }
  },
  data () {
    return {
      editor: null,
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        //excludeKeys: ["codeBlock" ],
      },
      editorConfig: this.getEditorConfig(),
      currentValue: ''
    }
  },
  computed: {
  },
  watch: {
    value(newValue) {
      this.valueChange(newValue);
    }
  },
  mounted () {
    this.$nextTick(() => {
      // 确保在组件挂载后初始化编辑器
      if (this.editor) {
        this.editor.destroy();
      }
    });
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁 editor
  },
  methods: {
    getEditorConfig() {
      let that = this
      const editorConfig = { 
        MENU_CONF: {},
        placeholder: this.$attrs.placeholder || '',
        autoFocus: false,
        scroll: true
      }
      editorConfig.MENU_CONF['uploadImage'] = {
        async customUpload(file, insertFn) {
          // 获取文件对象
          const uploadFile = file
          // 文件夹目录
          const prefix = 'text'
          const url = uploadOss(uploadFile.name, prefix)
          uploadObject(url, uploadFile).then(res => {
            insertFn(res, res, res)
          })
          let message = that.$t('通用.文本.上传成功');
          that.$message.success(message);
        }
      }
      editorConfig.MENU_CONF['uploadVideo'] = {
        async customUpload(file, insertFn) {
          // 获取文件对象
          const uploadFile = file
          // 文件夹目录
          const prefix = 'text'
          const url = uploadOss(uploadFile.name, prefix)
          uploadObject(url, uploadFile).then(res => {
            insertFn(res, res, res)
          })
          let message = that.$t('通用.文本.上传成功');
          that.$message.success(message);
        }
      }
      return editorConfig
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
      // 设置初始内容
      if (this.value) {
        editor.setHtml(this.value)
      }
    },
    onChange(editor) {
      this.currentValue = editor.getHtml()
      this.$emit('input', editor.getHtml())
    },
    valueChange(newValue) {
      if (this.editor && newValue !== this.currentValue) {
        this.currentValue = newValue
        this.editor.setHtml(newValue || '')
      }
    },
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
